export default "__VITE_ASSET__768a866e__"